/* Tears Of God — storefront app JS. Real Shopify cart (/cart.js, /cart/add.js, /cart/change.js).
   Cart mutations key on line.key (B-011). All injected strings escaped (B-016). */
(function(){
  var $=function(s,r){return (r||document).querySelector(s);};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  function esc(s){var d=document.createElement('div');d.textContent=(s==null?'':s);return d.innerHTML;}
  function money(cents){return '$'+(Math.round(cents)/100).toFixed(2);}
  function imgAt(url,w){if(!url)return '';return url+(url.indexOf('?')===-1?'?':'&')+'width='+w;} // B-002 separator guard

  // Cart data layer: products, the order-data recommendation map, and the promo
  // config. Emitted by snippets/tog-cart-drawer.liquid.
  var DATA={promo:{enabled:false},products:{},recs:{},cart_title:'Complete the fit',
            current:null,addboth_head:'',addboth_sub:''};
  try{
    var cn=document.querySelector('[data-tog-catalog]');
    if(cn){ var parsed=JSON.parse(cn.textContent); if(parsed&&parsed.products)DATA=parsed; }
  }catch(e){ /* keep the inert default; the drawer still works without upsells */ }
  // A cached older blob has no `current`/copy keys. Default them rather than
  // letting `undefined` reach esc() and print the string "undefined" at a
  // shopper. `current:null` also means the prompt simply never fires.
  if(DATA.current===undefined)DATA.current=null;
  if(!DATA.addboth_head)DATA.addboth_head="DON'T FORGET WHAT BROUGHT YOU HERE";
  if(!DATA.addboth_sub)DATA.addboth_sub="That piece isn't in your cart yet. Pick a size to add it.";
  function prod(h){ return DATA.products[h]||null; }

  // ---------- overlays ----------
  var scrim=$('[data-tog-scrim]'), cart=$('[data-tog-cart]'), mob=$('[data-tog-mob]'), guide=$('[data-tog-guide]');
  function openCart(){ if(cart){cart.classList.add('is-open');} if(scrim){scrim.classList.add('is-open');} }
  function closeCart(){ if(cart)cart.classList.remove('is-open'); if(scrim)scrim.classList.remove('is-open'); }
  function closeAll(){ closeCart(); if(mob)mob.classList.remove('is-open'); if(guide)guide.classList.remove('is-open'); }
  function toast(m){var t=$('[data-tog-toast]'); if(!t)return; t.textContent=m; t.classList.add('is-show'); clearTimeout(t._t); t._t=setTimeout(function(){t.classList.remove('is-show');},1800);}

  // Compare-at pricing. Mirrors the SSR pass in tog-cart-drawer.liquid: strike
  // the pre-discount line price when the shopper is paying less, from either a
  // cart discount (original_line_price) or a variant compare-at. Server truth
  // only -- we never print a saving the cart cannot back.
  function priceHtml(it){
    var was=0;
    if(it.original_line_price>it.final_line_price){ was=it.original_line_price; }
    else if(it.line_level_total_discount>0){ was=it.final_line_price+it.line_level_total_discount; }
    if(!was || was<=it.final_line_price) return money(it.final_line_price);
    return '<s class="tog-was">'+money(was)+'</s> <span class="tog-now">'
         +money(it.final_line_price)+'</span>';
  }

  // Percent-off badge. REAL line discounts only -- deliberately NOT compare-at.
  // 10 of this store's 12 products carry an $80 compare-at against a $75 price,
  // and /cart.js exposes no compare_at_price, so a compare-at badge would render
  // server-side and vanish here on the first re-render. Mirrors the disc_pct
  // assign in snippets/tog-cart-drawer.liquid; Math.floor is explicit because
  // JS "/" is float division while Liquid's divided_by on integers floors, and
  // the two renderers must never disagree on a non-even percentage.
  function badgeHtml(it){
    if(!(it.original_line_price>it.final_line_price)) return '';
    var pct=Math.floor((it.original_line_price-it.final_line_price)*100/it.original_line_price);
    return pct>=1 ? '<span class="tog-cbadge">'+pct+'% OFF</span>' : '';
  }

  // Write only when the rendered value or visibility actually changes. The
  // totals sit in one aria-live region, so an unconditional write would
  // re-announce an unchanged subtotal every time the drawer opens.
  function setText(el,v){ if(el && el.textContent!==v) el.textContent=v; }
  function setShown(el,on){
    if(!el) return;
    if(on===!el.hasAttribute('hidden')) return;
    if(on) el.removeAttribute('hidden'); else el.setAttribute('hidden','');
  }

  // ---------- cart render ----------
  function renderCart(c){
    var lines=$('[data-tog-lines]'); if(!lines)return;
    if(!c.items || !c.items.length){
      lines.innerHTML='<p class="tog-cart__empty">Your cart is empty</p>';
    } else {
      lines.innerHTML=c.items.map(function(it){
        var opts=(it.options_with_values||[]).map(function(o){return esc(o.value);}).join(' · ');
        return '<div class="tog-cline"><img src="'+esc(imgAt(it.image,128))+'" alt="'+esc(it.product_title)+'">'
          +'<div class="tog-cline__mid"><div class="tog-cline__n">'+esc(it.product_title)+'</div>'
          +'<div class="tog-cline__s">'+(opts||'')+'</div>'
          +badgeHtml(it)
          +'<div class="tog-cline__qty"><button data-tog-qty="'+esc(it.key)+'" data-d="-1" aria-label="Decrease quantity">−</button>'
          +'<span>'+it.quantity+'</span><button data-tog-qty="'+esc(it.key)+'" data-d="1" aria-label="Increase quantity">+</button></div></div>'
          +'<div class="tog-cline__right"><div class="tog-cline__p">'+priceHtml(it)+'</div>'
          +'<button class="tog-cline__rm" data-tog-remove="'+esc(it.key)+'">Remove</button></div></div>';
      }).join('');
    }
    $$('[data-tog-count]').forEach(function(el){el.textContent=c.item_count;});
    setText($('[data-tog-subtotal]'),money(c.total_price));
    // "You saved" -- cart-wide total_discount, server truth. Mirrors the SSR row
    // in tog-cart-drawer.liquid. Makes no BOGO-specific claim; do not rewire it
    // to the promo's title-matched allocation.
    var disc=c.total_discount||0;
    setText($('[data-tog-save-amt]'),'−'+money(disc));
    setShown($('[data-tog-save]'),disc>0);
    var ship=$('[data-tog-ship]');
    if(ship){ if(c.item_count>0){ship.removeAttribute('hidden');} else {ship.setAttribute('hidden','');} }
    // Promo first: when it is making an offer it OWNS the cross-sell slot, and
    // "Complete the fit" stands down rather than stacking a second offer under
    // it. Once both jackets are in the cart the promo is only a confirmation
    // banner, so the normal cross-sell comes back.
    // Order is load-bearing: the promo decides first, the prompt stands down to
    // it, and the cross-sell stands down to whichever of the two took the slot.
    var promoOffering = applyPromoState(c);
    var promptShowing = renderAddBoth(c, promoOffering);
    renderUpsell(c, promoOffering || promptShowing);
  }

  // Cart cross-sell, driven by the co-purchase map (custom.cross_sell), NOT by a
  // title heuristic. Walks each cart line's recommendations in rank order and
  // takes the first candidate that is available and not already in the cart.
  function renderUpsell(c, suppressed){
    var zone=$('[data-tog-upsell]'); if(!zone)return;
    zone.innerHTML='';
    if(suppressed)return;
    if(!c.items || !c.items.length)return;
    var inCart={};
    c.items.forEach(function(it){ inCart[it.handle]=true; });

    var pick=null, pickHandle=null, pickSource='fallback';
    for(var i=0;i<c.items.length && !pick;i++){
      var list=DATA.recs[c.items[i].handle]||[];
      for(var j=0;j<list.length;j++){
        var h=list[j].h, p=prod(h);
        if(!p || !p.available || inCart[h])continue;
        // The promo device owns the jacket pairing; don't duplicate it here.
        if(DATA.promo.enabled && (h===DATA.promo.qualifier || h===DATA.promo.discounted))continue;
        // Report the TRUE source. Hardcoding "copurchase" here would label a
        // fallback pick as order evidence, which is the one thing the source
        // attribute exists to prevent.
        pick=p; pickHandle=h; pickSource=list[j].s||'fallback'; break;
      }
    }
    if(!pick)return;

    // R1: never blind-add a multi-size garment. One available variant => a
    // direct Add; otherwise the same size-chip picker the product cards use.
    var action;
    if(pick.sizes.length===1){
      action='<button class="tog-upsell__add" data-tog-upadd="'+esc(pick.sizes[0].id)
            +'" data-title="'+esc(pick.title)+'">Add</button>';
    } else {
      action='<div class="tog-upsell__sizes">'+pick.sizes.map(function(s){
        return '<button type="button" class="tog-szchip" data-variant-id="'+esc(s.id)
             +'" data-title="'+esc(pick.title)+'">'+esc(s.label)+'</button>';
      }).join('')+'</div>';
    }
    zone.innerHTML='<div class="tog-cart__upsell-h">'+esc(DATA.cart_title)+'</div>'
      +'<div class="tog-upsell" data-tog-rec-source="'+esc(pickSource)+'" data-tog-rec-handle="'+esc(pickHandle)+'">'
      +'<a href="'+esc(pick.url)+'"><img src="'+esc(imgAt(pick.img,120))+'" alt="'+esc(pick.title)+'"></a>'
      +'<div><div class="tog-upsell__n">'+esc(pick.title)+'</div>'
      +'<div class="tog-upsell__p">'+money(pick.price)+'</div></div>'
      +action+'</div>';
  }

  // ---------- "you didn't add what you came for" ----------
  // Armed by a size-chip add inside the PDP's WORN TOGETHER rail; cleared the
  // moment the viewed product reaches the cart, so the prompt cannot outlive
  // the situation it describes. In-memory by design: after a reload there is
  // no click to react to, and the server cannot know one happened either.
  var railAdd=false;

  // Returns true when the prompt is on screen, so the caller can stand the
  // "Complete the fit" cross-sell down: one ask at a time (Derrick 2026-09-11).
  function renderAddBoth(c, promoOffering){
    var zone=$('[data-tog-addboth]'); if(!zone)return false;
    var h=DATA.current;                       // null on every non-product template
    var p=h?prod(h):null;
    var inCart=(c.items||[]).some(function(it){return it.handle===h;});
    if(inCart)railAdd=false;                  // they added it; the prompt is spent

    // Every condition must hold: armed, on a PDP, product known, still buyable,
    // still absent, and the cart not empty (an empty cart means they removed
    // everything and the prompt would be nagging about nothing).
    //
    // `promoOffering` outranks this prompt. In every cart state where the BOGO
    // is actually reachable the His & Her nudge is already making the ask WITH a
    // discount attached -- a strictly better reason to act than "you forgot
    // this". Without this guard both devices render at once, which is the exact
    // duplication the rail-only scoping was chosen to avoid.
    if(promoOffering || !railAdd || !p || !p.available || !p.sizes.length || inCart || !(c.items||[]).length){
      setShown(zone,false); zone.innerHTML=''; return false;
    }

    var chips=p.sizes.map(function(s){
      return '<button type="button" class="tog-szchip" data-variant-id="'+esc(s.id)
           +'" data-title="'+esc(p.title)+'">'+esc(s.label)+'</button>';
    }).join('');
    zone.innerHTML='<div class="tog-cart__addboth-h">'+esc(DATA.addboth_head)+'</div>'
      +'<p class="tog-cart__addboth-s">'+esc(DATA.addboth_sub)+'</p>'
      +'<div class="tog-upsell" data-tog-rec-source="addboth" data-tog-rec-handle="'+esc(h)+'">'
      +'<a href="'+esc(p.url)+'"><img src="'+esc(imgAt(p.img,120))+'" alt="'+esc(p.title)+'"></a>'
      +'<div><div class="tog-upsell__n">'+esc(p.title)+'</div>'
      +'<div class="tog-upsell__p">'+money(p.price)+'</div></div>'
      +'<div class="tog-upsell__sizes">'+chips+'</div></div>';
    setShown(zone,true);
    return true;
  }

  // ---------- His & Her promo state ----------
  // Single source of truth for EVERY promo node on the page (PDP device + cart
  // drawer nudge). Called after every cart response and on pageshow, so a PDP
  // badge cannot go stale after an AJAX add or a Back navigation.
  //
  // "Unlocked" is read from the DISCOUNT, never inferred from which handles are
  // in the cart: this promo combines with nothing, so a code discount can
  // suppress it and leave both jackets present but undiscounted.
  // /cart.js returns the discount title HTML-ESCAPED ("His &amp; Her Deal &lt;3")
  // while Liquid hands us the raw string. Comparing them directly silently never
  // matches, so the unlocked state would never appear. Normalize both sides.
  // (Caught by driving a real cart, not by reading the code.)
  function deent(v){ var t=document.createElement('textarea'); t.innerHTML=(v==null?'':String(v)); return t.value.trim(); }

  function promoApplied(c){
    var pm=DATA.promo, total=0, want=deent(pm.title);
    if(!pm.enabled || !c.items)return 0;
    c.items.forEach(function(it){
      if(it.handle!==pm.discounted)return;
      // Sum across ALL matching lines: Shopify splits a line when a discount
      // covers some units but not others.
      (it.discounts||it.discount_allocations||[]).forEach(function(d){
        var title=deent((d.discount_application&&d.discount_application.title)||d.title||'');
        var amt=(d.amount!=null?d.amount:d.discounted_amount)||0;
        if(title===want)total+=amt;
      });
    });
    return total;
  }
  function applyPromoState(c){
    var pm=DATA.promo;
    var has={};
    (c.items||[]).forEach(function(it){ has[it.handle]=true; });
    var applied=promoApplied(c);

    // PDP device
    $$('[data-tog-hisher]').forEach(function(node){
      node.classList.toggle('is-unlocked', applied>0);
      var st=$('[data-tog-hisher-status]',node);
      if(st && applied>0){
        st.innerHTML='<span class="tog-hisher__on">'+esc(pm.unlocked)+' — '+money(applied)+' OFF</span>';
      }
    });

    // Cart drawer nudge. Rendered as a real upsell row -- same markup and
    // classes as "Complete the fit" -- so the shopper picks a size and it drops
    // straight into the cart, instead of being sent off to a PDP. Which jacket
    // it offers depends on which one is MISSING from the cart.
    var zone=$('[data-tog-promo]'); if(!zone)return false;
    if(!pm.enabled){ zone.setAttribute('hidden',''); zone.innerHTML=''; return false; }

    var head='', addHandle=null;
    if(applied>0){
      head=pm.unlocked+' — '+money(applied)+' off';
    } else if(has[pm.qualifier] && !has[pm.discounted]){
      head=pm.head_needs_discounted; addHandle=pm.discounted;
    } else if(has[pm.discounted] && !has[pm.qualifier]){
      head=pm.head_needs_qualifier; addHandle=pm.qualifier;
    }
    if(!head){ zone.setAttribute('hidden',''); zone.innerHTML=''; return false; }

    var p=addHandle?prod(addHandle):null;
    var html='<div class="tog-cart__upsell-h">'+esc(head)+'</div>';
    // Supporting line only while an OFFER is on the table. The applied state is a
    // confirmation banner -- "this piece isn't in your cart yet" would contradict
    // the very thing it is confirming.
    if(addHandle && DATA.promo.nudge_sub){
      html+='<p class="tog-cart__promo-s">'+esc(DATA.promo.nudge_sub)+'</p>';
    }
    if(p && p.available && p.sizes.length){
      // Size chips, never a blind add -- both jackets carry six sizes.
      var chips=p.sizes.map(function(sz){
        return '<button type="button" class="tog-szchip" data-variant-id="'+esc(sz.id)
             +'" data-title="'+esc(p.title)+'">'+esc(sz.label)+'</button>';
      }).join('');
      html+='<div class="tog-upsell" data-tog-rec-source="promo" data-tog-rec-handle="'+esc(addHandle)+'">'
          +'<a href="'+esc(p.url)+'"><img src="'+esc(imgAt(p.img,120))+'" alt="'+esc(p.title)+'"></a>'
          +'<div><div class="tog-upsell__n">'+esc(p.title)+'</div>'
          +'<div class="tog-upsell__p">'+money(p.price)+'</div></div>'
          +'<div class="tog-upsell__sizes">'+chips+'</div></div>';
    } else if(p){
      html+='<div class="tog-upsell"><div><div class="tog-upsell__n">'+esc(p.title)+'</div>'
          +'<div class="tog-upsell__p">Sold out</div></div></div>';
    }

    zone.classList.toggle('is-on', applied>0);
    zone.innerHTML=html;
    zone.removeAttribute('hidden');
    // Only an actual product offer takes the slot; the applied banner does not.
    return !!addHandle;
  }
  // Every cart mutation runs through ONE chain, so a fast double-tap cannot
  // interleave two writes, and a response from a superseded request cannot
  // repaint over a newer one.
  var _chain=Promise.resolve(), _gen=0, _busy=false;
  function serialize(fn){
    var mine=++_gen;
    _chain=_chain.then(function(){ return fn(); }).then(function(res){
      if(mine!==_gen)return res;   // superseded: do not paint
      return res;
    }).catch(function(e){
      if(mine===_gen)toast('COULD NOT UPDATE CART');
      return null;
    });
    return _chain;
  }
  function jsonOrThrow(r){
    if(!r.ok)return r.json().then(function(e){throw e;},function(){throw new Error('HTTP '+r.status);});
    return r.json();
  }
  function fetchCart(open){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(jsonOrThrow)
      .then(function(c){renderCart(c); if(open)openCart(); return c;});
  }
  function addVariant(id,qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:id,quantity:qty||1})}).then(jsonOrThrow);
  }
  // Guarded add: one in flight at a time. Without this a double-click on an
  // upsell button adds the item twice and the shopper only notices at checkout.
  function addGuarded(id,title){
    if(_busy)return Promise.resolve(null);
    _busy=true;
    return serialize(function(){
      return addVariant(id,1)
        .then(function(){ return fetchCart(true); })
        .then(function(c){ toast(title?('ADDED — '+title):'ADDED TO CART'); return c; });
    }).then(function(c){ _busy=false; return c; },
            function(e){ _busy=false; throw e; });
  }
  function changeLine(key,qty){
    return serialize(function(){
      return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:key,quantity:qty})})   // id=line.key (B-011)
        .then(jsonOrThrow)
        .then(function(c){ renderCart(c); return c; })
        .catch(function(e){
          // A BXGY allocation can split or re-key a line mid-session. Recover by
          // repainting from server truth rather than guessing at a replacement.
          return fetchCart(false).then(function(){ throw e; });
        });
    });
  }

  // ---------- quick-add size picker (cards) ----------
  function closePickers(except){$$('.tog-card__add.is-picking').forEach(function(x){if(x!==except)x.classList.remove('is-picking');});}

  document.addEventListener('click',function(e){
    var t;
    if((t=e.target.closest('[data-tog-cartopen]'))){e.preventDefault();fetchCart(true);return;}
    if((t=e.target.closest('[data-tog-cartclose]'))){closeCart();return;}
    if((t=e.target.closest('[data-tog-scrim]'))){closeAll();return;}
    if((t=e.target.closest('[data-tog-mobopen]'))){if(mob)mob.classList.add('is-open'); if(scrim)scrim.classList.add('is-open'); return;}
    if((t=e.target.closest('[data-tog-mobclose]'))){closeAll();return;}
    if((t=e.target.closest('[data-tog-guideopen]'))){if(guide)guide.classList.add('is-open');return;}
    if((t=e.target.closest('[data-tog-guideclose]'))){if(guide)guide.classList.remove('is-open');return;}
    // cart qty + remove (keyed on line.key)
    if((t=e.target.closest('[data-tog-qty]'))){changeLineByDelta(t.getAttribute('data-tog-qty'),parseInt(t.getAttribute('data-d'),10));return;}
    if((t=e.target.closest('[data-tog-remove]'))){changeLine(t.getAttribute('data-tog-remove'),0);return;}
    // cart upsell add (complete the fit)
    if((t=e.target.closest('[data-tog-upadd]'))){
      e.preventDefault();
      var uvid=t.getAttribute('data-tog-upadd'), utitle=t.getAttribute('data-title')||'Item';
      addGuarded(uvid,utitle);
      return;
    }
    // PDP accordion
    if((t=e.target.closest('[data-tog-acc]'))){t.closest('.tog-acc__item').classList.toggle('is-open');return;}
    // gallery thumb
    if((t=e.target.closest('[data-tog-thumb]'))){var trk=$('[data-tog-gal-track]'); var gi=parseInt(t.getAttribute('data-index'),10)||0; if(trk)trk.scrollTo({left:gi*trk.clientWidth,behavior:'smooth'}); return;}
    // + ADD -> reveal size chips
    if((t=e.target.closest('.tog-card__addbtn'))){e.preventDefault();var w=t.closest('.tog-card__add');closePickers(w);w.classList.toggle('is-picking');return;}
    // pick size chip -> add that variant
    if((t=e.target.closest('.tog-szchip'))){
      e.preventDefault();
      var vid=t.getAttribute('data-variant-id'); var title=t.getAttribute('data-title')||'Item';
      if(!vid)return;
      var wrap=t.closest('.tog-card__add'); if(wrap)wrap.classList.remove('is-picking');
      // Arm the "you didn't add what you came for" prompt, but ONLY for the PDP's
      // WORN TOGETHER rail. The same .tog-szchip markup is also used by the
      // collection grid, the cart drawer's own cross-sell and the His & Her
      // device -- scoping on [data-tog-recs] is what keeps this off all three.
      if(t.closest('[data-tog-recs]')) railAdd=true;
      addGuarded(vid,title);
      return;
    }
    if(!e.target.closest('.tog-card__add'))closePickers(null);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});

  // Read-then-write, but inside the serialized chain so two rapid taps cannot
  // both read the same starting quantity and clobber each other.
  function changeLineByDelta(key,d){
    return serialize(function(){
      return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(jsonOrThrow).then(function(c){
        var it=c.items.filter(function(x){return x.key===key;})[0];
        if(!it){ renderCart(c); return c; }   // line already gone: repaint truth
        return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:key,quantity:Math.max(0,it.quantity+d)})})
          .then(jsonOrThrow).then(function(nc){ renderCart(nc); return nc; });
      });
    });
  }

  // ---------- PDP variant selection (multi-option: Color, Size, …) ----------
  var vdata=$('[data-tog-variants]');
  if(vdata){
    var VARIANTS=[]; try{ VARIANTS=JSON.parse(vdata.textContent)||[]; }catch(e){ VARIANTS=[]; }
    var vform=$('#tog-atc-form');
    var vId=vform?$('[data-tog-variant-id]',vform):null;
    var vPrice=$('[data-tog-price]');
    var vTrack=$('[data-tog-gal-track]');
    var vAdd=vform?vform.querySelector('button[type="submit"]'):null;
    var vSticky=$('[data-tog-stickyatc]');
    var vSs=vSticky?$('[data-tog-sticky-size]',vSticky):null;
    // color-name -> hex (sampled from the actual product images); falls back to CSS name, then grey
    var COLOR_MAP={'hot pink':'#F04070','dark green':'#207030','light pink':'#E0A0B0','gray':'#808080','grey':'#808080','light green':'#4FA84F','black':'#101010','white':'#FFFFFF','navy':'#1F2A44','cream':'#EFE7D6','brown':'#5A4636','red':'#C33127'};
    $$('.tog-swatch',vform).forEach(function(el){ var n=(el.getAttribute('data-color')||'').toLowerCase().trim(); el.style.background=COLOR_MAP[n]||n.replace(/\s+/g,'')||'#ccc'; });
    function cssEsc(s){ return (window.CSS&&CSS.escape)?CSS.escape(s):s.replace(/"/g,'\\"'); }
    function selOpts(){ var o=[]; $$('[data-tog-optvalues]',vform).forEach(function(g){ var i=parseInt(g.getAttribute('data-opt-index'),10)-1; var c=g.querySelector('input:checked'); o[i]=c?c.value:null; }); return o; }
    function sizeVal(){ var s=null; $$('[data-tog-optvalues]',vform).forEach(function(g){ if((g.getAttribute('data-opt-name')||'').toLowerCase()==='size'){ var c=g.querySelector('input:checked'); if(c)s=c.value; } }); return s; }
    function setOpt(name,value){ $$('[data-tog-optvalues]',vform).forEach(function(g){ if((g.getAttribute('data-opt-name')||'').toLowerCase()===name.toLowerCase()){ var r=g.querySelector('input[value="'+cssEsc(value)+'"]'); if(r)r.checked=true; } }); }
    function findVar(o){ return VARIANTS.filter(function(v){ for(var i=0;i<o.length;i++){ if(o[i]!=null && v.options[i]!==o[i]) return false; } return true; })[0]; }
    function vUpdate(){
      var v=findVar(selOpts());
      if(!v){ if(vAdd){vAdd.disabled=true;vAdd.textContent='Unavailable';} return; }
      if(vId)vId.value=v.id;
      if(vPrice)vPrice.textContent=money(v.price);
      if(vTrack && v.featured_image && v.featured_image.id){ for(var k=0;k<vTrack.children.length;k++){ if(parseInt(vTrack.children[k].getAttribute('data-img-id'),10)===v.featured_image.id){ vTrack.scrollTo({left:k*vTrack.clientWidth,behavior:'smooth'}); break; } } }
      if(vAdd){ vAdd.disabled=!v.available; vAdd.textContent=v.available?'Add to Cart':'Sold Out'; }
      if(vSs){ var s=sizeVal(); if(s!=null)vSs.value=s; }
      var scl=$('[data-tog-selected-color]');
      if(scl){ $$('[data-tog-optvalues]',vform).forEach(function(g){ if((g.getAttribute('data-opt-name')||'').toLowerCase()==='color'){ var c=g.querySelector('input:checked'); if(c)scl.textContent=c.value; } }); }
    }
    function vAddToCart(){
      var v=findVar(selOpts());
      if(!v){ toast('SELECT OPTIONS'); return; }
      if(!v.available){ toast('SOLD OUT'); return; }
      addGuarded(v.id,null);
    }
    if(vform){
      vform.addEventListener('change',function(e){ if(e.target.name && e.target.name.indexOf('tog-opt-')===0) vUpdate(); });
      vform.addEventListener('submit',function(e){ e.preventDefault(); vAddToCart(); });
    }
    if(vSs){ vSs.addEventListener('change',function(){ setOpt('Size', this.value); vUpdate(); }); }
    if(vSticky){
      $('[data-tog-sticky-add]',vSticky).addEventListener('click',vAddToCart);
      if('IntersectionObserver' in window && vform){
        new IntersectionObserver(function(es){es.forEach(function(en){
          vSticky.classList.toggle('is-visible', !en.isIntersecting);
          vSticky.setAttribute('aria-hidden', en.isIntersecting ? 'true' : 'false');
        });},{threshold:0, rootMargin:'0px 0px -40px 0px'}).observe(vform);
      }
    }
    vUpdate();
  }

  // ---------- PDP gallery: sync active thumb on swipe/scroll ----------
  var galTrack=$('[data-tog-gal-track]');
  if(galTrack){
    var galThumbs=$$('.tog-gal__thumb'), galTick=false;
    galTrack.addEventListener('scroll',function(){
      if(galTick)return; galTick=true;
      requestAnimationFrame(function(){
        var idx=Math.round(galTrack.scrollLeft/galTrack.clientWidth);
        galThumbs.forEach(function(x,i){x.classList.toggle('is-active', i===idx);});
        galTick=false;
      });
    },{passive:true});
  }

  // ---------- rotating scripture band (with dots) ----------
  var scrip=$('[data-tog-scripture]');
  if(scrip){
    var slides=$$('.tog-verse__slide',scrip);
    var dots=$$('[data-tog-dots] .tog-verse__dot',scrip);
    var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(slides.length>1){
      var iv=(parseInt(scrip.getAttribute('data-interval'),10)||5)*1000, si=0, timer=null;
      function scripGo(n){
        slides[si].classList.remove('is-active'); if(dots[si])dots[si].classList.remove('is-active');
        si=(n+slides.length)%slides.length;
        slides[si].classList.add('is-active'); if(dots[si])dots[si].classList.add('is-active');
      }
      function scripStart(){ if(reduce)return; timer=setInterval(function(){scripGo(si+1);}, iv); }
      dots.forEach(function(d,i){ d.addEventListener('click',function(){ scripGo(i); clearInterval(timer); scripStart(); }); });
      scripStart();
    }
  }

  // Initial hydrate (header count + drawer contents).
  fetchCart(false);

  // BFCache: coming Back from checkout restores the JS heap, so any in-flight
  // busy flag survives and every control silently no-ops. Reset and re-read.
  window.addEventListener('pageshow',function(e){
    if(e.persisted){ _busy=false; _gen++; fetchCart(false); }
  });
})();
